<template>
  <div class="row root">
    <linear-loader text="loading products" />
    <!-- <card-loader v-for="i in 4" :key="`loader-${i}`">
      <card-loader-box width="100%" height="180px"></card-loader-box>

      <div class="row mt-1">
        <div class="sm-8">
          <card-loader-text class="mb-1"></card-loader-text>
          <card-loader-text width="80px"></card-loader-text>
        </div>
      </div>
    </card-loader> -->
  </div>
</template>

<script>
import LinearLoader from '@/components/loaders/LinearLoader';
// import CardLoader from '@/components/loaders/CardLoader';
// import CardLoaderBox from '@/components/loaders/CardLoader/CardLoaderBox';
// import CardLoaderText from '@/components/loaders/CardLoader/CardLoaderText';

export default {
  name: 'ProductsLoading',
  components: {
    // CardLoader,
    // CardLoaderBox,
    // CardLoaderText,
    LinearLoader,
  }
}
</script>

<style lang="scss" scoped>
.root {
  justify-content: space-between;
  gap: 2ch;
}

.card-loader {
  flex: 1;
  flex-grow: 0;
  min-width: 200px;

  @media only screen and (max-width: 600px) {
    min-width: 100%;
  }
}
</style>